module.exports = __webpack_public_path__ + "static/Michal_2-79402b0831677996b4861489bb7f94f5.jpg";